import { InvoiceStates, UserRols } from "../../../constants";

export const AllowUserMoreOptionsSales = [
	UserRols.DEFAULT_USER,
	UserRols.ORG_ADMIN,
	UserRols.ARO_ADMIN,
	UserRols.ACCOUNTANT,
];

export const AllowedInvoicesStatesForEditSales = [
	InvoiceStates.UNVERIFIED,
];

export const UnallowedUserForEditSales = [
	UserRols.BILLING,
];

export const AllowedInvoicesStatesForMassiveVerificationSales = [
	InvoiceStates.HISTORY,
	InvoiceStates.EXCLUDED,
	InvoiceStates.NOTIFICATION_SENT,
	InvoiceStates.ERROR,
];